import {
  Autocomplete,
  TextField,
  Box,
  Button,
  Divider,
  CircularProgress,
  AutocompleteProps,
  // AutocompleteProps,
} from '@mui/material';
import SearchIcon from '@old/assets/svg/core/search-black.svg';
import React, { useState, useRef } from 'react';

type AutocompleteType = Omit<AutocompleteProps<string, boolean, boolean, boolean>, 'renderInput'> & {
  renderInput?: AutocompleteProps<string, boolean, boolean, boolean>['renderInput'];
};

type AutocompleteInputProps = {
  label: string;
  options: string[] | undefined;
  loading: boolean;
  onInnerSelect: (value: string) => void;
  onInnerInputChange: (value: string) => void; // Cambiado a InputChg
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  value?: string | null;
  inputValue?: string;
  width?: number;
};

export function AutocompleteInput(props: AutocompleteInputProps & AutocompleteType) {
  const {
    label,
    options,
    loading,
    onInnerInputChange,
    search,
    setSearch,
    onKeyDown,
    disabled = false,
    value,
    width = 300,
    onInnerSelect,
    ...autocomleteProps
  } = props;

  const [openPredictive, setOpenPredictive] = useState(false);
  const isLoadingRef = useRef(false);

  return (
    <Autocomplete
      disabled={disabled}
      value={value}
      clearOnEscape
      clearOnBlur
      slotProps={{ paper: { sx: { width } } }}
      open={openPredictive && Boolean(search)}
      inputValue={search}
      loading={loading}
      loadingText="Searching..."
      noOptionsText="No results"
      onBlur={() => {
        setOpenPredictive(false);
        isLoadingRef.current = false;
      }}
      onOpen={() => setOpenPredictive(true)}
      onInputChange={(event, newInputValue) => {
        if (!event || event.type === 'blur') return;
        setSearch(newInputValue);
        isLoadingRef.current = true;

        // Llamar al handler con el evento adecuado usando la función createInputChg
        if (onInnerInputChange) {
          onInnerInputChange(newInputValue);
        }
      }}
      getOptionLabel={(option: string) => option}
      options={loading ? [] : options ?? []}
      renderOption={(_, option, state) => (
        <Box key={option} maxWidth={'100%'}>
          <Button
            style={{ color: 'black', padding: 3, minWidth: 20, zIndex: 1, textAlign: 'start' }}
            fullWidth
            onClick={() => onInnerSelect(option)} // Ejecutamos el handler cuando seleccionamos una opción
          >
            {option}
          </Button>
          {state.index !== (options?.length ?? 0) - 1 ? <Divider /> : null}
        </Box>
      )}
      {...autocomleteProps}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          value={search}
          sx={{ width: width }}
          size="small"
          onChange={(event) => {
            setSearch(event.target.value);
            if (onInnerInputChange) {
              // Llamar al handler cuando el input cambie
              onInnerInputChange(event.target.value); // Aquí pasamos el evento con InputChg
            }
          }}
          onKeyDown={onKeyDown} // Manejamos el evento de teclado
          InputProps={{
            ...params.InputProps,
            startAdornment: <img style={{ width: 14, height: 14 }} src={SearchIcon} />,
            endAdornment: loading ? <CircularProgress size={18} thickness={6} /> : null,
          }}
        />
      )}
    />
  );
}
